/**
 * Shopify Storefront API Client
 * This file initializes the Shopify Storefront API client using environment variables
 */

import { createStorefrontApiClient } from "@shopify/storefront-api-client";
import { envConfig } from "@/shopify/env-config";

/**
 * Initialize the Shopify Storefront API client with configuration from environment variables
 *
 * To use this client, ensure the following environment variables are set:
 * - NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: Your Shopify store domain (e.g., your-shop-name.myshopify.com)
 * - NEXT_PUBLIC_SHOPIFY_API_VERSION: Shopify API version (default: 2025-04)
 * - NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: Your Shopify Storefront API access token
 */
export const storefrontClient = createStorefrontApiClient({
  storeDomain: envConfig.shopify.storeDomain,
  apiVersion: envConfig.shopify.apiVersion,
  publicAccessToken: envConfig.shopify.storefrontAccessToken,
});

export default storefrontClient;
